module.exports = __webpack_public_path__ + "static/29-8bf5145c348edb8d39b01afee30e54f0.png";